const Data =[
    {
        name: "Akash Agarwal",
        position: "Chief Executive Officer, LiGHT",
        imageUrl: "/assets/images/members/Akash Agarwal.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/"
    },
    {
        name: "Udeshya Raj",
        position: "LiGHT Coordinator",
        imageUrl: "/images/profile.png",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/"
    },
    {
        name: "Saamarth Singh",
        position: "LiGHT Coordinator",
        imageUrl: "/assets/images/members/SaamarthSingh.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/"
    },
    {
        name: "Sanidhya Prakash Singh",
        position: "LiGHT Coordinator",
        imageUrl: "/assets/images/members/SanidhyaPrakashSingh.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/"
    },
]

export default Data;